<template>
    <div>
      <section class="signin popup-in">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="single-sign">
                <div class="sign-content popup-in-content">
                  <div class="popup-in-txt">
                    <h2>sign in</h2>

                    <div class="signin-form">
                      <div class=" ">
                        <div class=" ">

                          <form action="signin.html">
                            <div class="form-group">
                              <label for="username">Name</label>
                              <input type="email" class="form-control" id="username" placeholder="username" v-model="username">
                            </div><!--/.form-group -->
                            <div class="form-group">
                              <label for="password">password</label>
                              <input type="password" class="form-control" id="password" placeholder="Password" v-model="password">
                            </div><!--/.form-group -->
                          </form><!--/form -->
                        </div><!--/.col -->
                      </div><!--/.row -->

                    </div><!--/.signin-form -->
                    <div class="signin-password">
                      <div class="awesome-checkbox-list">
                        <ul class="unstyled centered">

                          <li>
                            <input class="styled-checkbox" id="styled-checkbox-2" type="checkbox" value="value2">
                            <label for="styled-checkbox-2">Keep me Signed in</label>
                          </li>

                          <li>
                            <a href="#">Forgot email or password ?</a>
                          </li>

                        </ul>
                      </div><!--/.awesome-checkbox-list -->
                    </div><!--/.signin-password -->
                    <div>
                      <img  :src="imgurl" alt="" id="img">
                    </div>
                    <div class="signin-footer">
                      <button type="button" class="btn signin_btn" data-toggle="modal"   v-on:click="setLogin()" v-bind:data-target="myModal">
                        sign in
                      </button>
                      <p>
                        Don’t have an Account ?
                        <router-link to="singup">register</router-link>
                      </p>
                    </div><!--/.signin-footer -->

                  </div><!--/.popup-in-txt -->
                </div><!--/.sign-content -->
              </div><!--/.single-sign -->
            </div><!--/.col -->
          </div><!--/.row-->
        </div><!--/.container -->
      </section><!--/.signin -->

      <!-- signin end -->

      <!--footer copyright start -->
      <footer class="footer-copyright">
        <div id="scroll-Top">
          <i class="fa fa-angle-double-up return-to-top" id="scroll-top" data-toggle="tooltip" data-placement="top" title="" data-original-title="Back to Top" aria-hidden="true"></i>
        </div><!--/.scroll-Top-->

      </footer><!--/.hm-footer-copyright-->
      <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                &times;
              </button>
              <h4 class="modal-title" id="myModalLabel">
                提示
              </h4>
            </div>
            <div class="modal-body">
            {{message}}
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">关闭
              </button>
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                确定
              </button>
            </div>
          </div><!-- /.modal-content -->
        </div><!-- /.modal -->
      </div>
      <router-view></router-view>
    </div>
</template>

<script>
import https from './js/https.js'
import Vue from 'vue'
export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      myModal: '',
      message: '',
      imgurl: ''
    }
  },
  methods: {
    // 登录接口
    setLogin () {
      var urname = /^.{3,10}$/
      var paward = /^.{6,10}$/
      if (this.username == '' || this.username == null) {
        this.message = '请输入用户名'
        console.log('请输入用户名')
        return false
      } else if (!urname.test(this.username)) {
        this.myModal = '#myModal'
        this.message = '请输入6-10位的用户名'
        console.log('请输入6-10位的用户名')
      } else if (!paward.test(this.password)) {
        this.myModal = '#myModal'
        this.message = '请输入6到10位的密码'
        console.log('请输入大于6位的密码')
      } else {
        https.fetchPost('mocalilie/api/user/userLogin', {
          username: this.username,
          password: this.password
        }).then((res) => {
          console.log(res.data)
          if (res.data.code == '0') {
            this.message = '登陆成功'
            console.log('-----' + this)
            /* Vue.prototype.userid = res.data.data.userId
            this.$router.push('/') */
          } else {
            this.myModal = '#myModal'
            this.message = res.data.msg
          }
        })
      }
    },
    // websock () {
    //   var socket
    //   // 实现化WebSocket对象
    //   // 指定要连接的服务器地址与端口建立连接
    //   // ws对应http、wss对应https。
    //   socket = new WebSocket('ws://47.97.180.196:8080/mocalilie/ws/asset')
    //   // 连接打开事件
    //   socket.onopen = function () {
    //
    //   }
    //   // 收到消息事件
    //   socket.onmessage = function (msg) {
    //     var data = msg.data
    //     var str = data.substring(0, 4)
    //     console.log(msg)
    //     console.log(msg.data)
    //     if (str == '连接成功') {
    //       var IdIndex = msg.data.indexOf('ID=')
    //       var WSID = data.substring(IdIndex + 3).replace(')', '')
    //       var getRequest = new XMLHttpRequest()// 创建请求对象
    //       var url = 'http://47.97.180.196:8080/mocalilie/api/user/getImage?webWSID=' + WSID
    //       getRequest.open('GET', url, true)// 链接服务器
    //       getRequest.send()// 发送请求
    //       getRequest.onreadystatechange = function () {
    //         if (getRequest.readyState === 4) { // 请求已完成，且响应已就绪
    //           if (getRequest.status === 200) { // 请求成功
    //             var resultStr = getRequest.responseText// 获取结果
    //             var resultObj = JSON.parse(resultStr)// 解析数据
    //             console.log(resultObj.data)
    //
    //             /* //this.imgurl = resultObj.data.imgUrl */
    //
    //             this.imgurl = resultObj.data.imgUrl
    //             document.getElementById('img').src = resultObj.data.imgUrl
    //             console.log(this.imgurl)
    //             // $('#img').attr('src', imgUrl)// 展示图片
    //
    //             console.log(IdIndex)
    //             console.log(WSID)
    //             console.log('成功')
    //           }
    //         }
    //       }
    //     } else {
    //       console.log('开始回传' + data.substring(0, 7))
    //       if (data.substring(0, 7) == 'userId:') {
    //         console.log('开始回传')
    //         var parameter = data.substring(0, data.indexOf(' (From'))
    //         var userId = parameter.substring(0, parameter.indexOf('nick_name'))
    //         var name = parameter.substring(parameter.indexOf('nick_name'))
    //         console.log('参数为userId----' + userId)
    //         console.log('参数为name------' + name)
    //         this.message = '登陆成功'
    //         Vue.prototype.userid = userId
    //         // window.location.href = 'http://localhost:8089/'
    //         console.log(this.message)
    //       }
    //       console.log('失败')
    //     }
    //   }
    //   // 连接关闭事件
    //   socket.onclose = function () {
    //     console.log('Socket已关闭')
    //   }
    //   // 发生了错误事件
    //   socket.onerror = function () {
    //     console.log('Socket发生了错误')
    //   }
    //   // 窗口关闭时，关闭连接
    //   window.unload = function () {
    //     socket.close()
    //   }
    // }
    websock () {
      const wsuri = `ws://47.97.180.196:8080/mocalilie/ws/asset`
      this.websock = new WebSocket(wsuri) // 这里面的this都指向vue
      this.websock.onopen = this.websocketopen
      this.websock.onmessage = this.websocketonmessage
      this.websock.onclose = this.websocketclose
      this.websock.onerror = this.websocketerror
    },
    websocketopen () { // 打开
      console.log('WebSocket连接成功')
    },
    websocketonmessage (res) { // 数据接收
      console.log(res)
      var str = res.data.substring(0, 4)
      if (str == '连接成功') {
        var IdIndex = res.data.indexOf('ID=')
        var WSID = res.data.substring(IdIndex + 3).replace(')', '')
        var getRequest = new XMLHttpRequest()// 创建请求对象
        var url = 'http://47.97.180.196:8080/mocalilie/api/user/getImage?webWSID=' + WSID
        getRequest.open('GET', url, true)// 链接服务器
        getRequest.send()// 发送请求
        getRequest.onreadystatechange = function () {
          if (getRequest.readyState === 4) { // 请求已完成，且响应已就绪
            if (getRequest.status === 200) { // 请求成功
              var resultStr = getRequest.responseText// 获取结果
              var resultObj = JSON.parse(resultStr)// 解析数据
              console.log(resultObj.data)

              /* //this.imgurl = resultObj.data.imgUrl */

              this.imgurl = resultObj.data.imgUrl
              document.getElementById('img').src = resultObj.data.imgUrl
              console.log(this.imgurl)
              // $('#img').attr('src', imgUrl)// 展示图片

              console.log(IdIndex)
              console.log(WSID)
              console.log('成功')
            }
          }
        }
      } else {
        console.log('开始回传' + res.data.substring(0, 7))
        if (res.data.substring(0, 7) == 'userId:') {
          console.log('开始回传')
          var parameter = res.data.substring(0, res.data.indexOf(' (From'))
          var userId = parameter.substring(7, parameter.indexOf('nick_name'))
          var name = parameter.substring(parameter.indexOf('nick_name'))
          console.log('参数为userId----' + userId)
          console.log('参数为name------' + name)
          this.message = '登陆成功'
          Vue.prototype.userid = userId
          sessionStorage.setItem('userId', userId)
          // window.location.href = 'http://localhost:8089/'
          this.$router.push('/')
          console.log(Vue.prototype.userid)
        }
        console.log('失败')
      }
    },
    websocketclose () { // 关闭
      // console.log("WebSocket关闭");

    },
    websocketerror () { // 失败
      //  console.log("WebSocket连接失败");
    }
  },
  created () {
    this.websock()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Login.vue